import { FunctionComponent } from 'preact';
import type { Asset } from '@schibsted-svp/svp-api-types';

import { useNextAsset } from '../../hooks/NextAssetProvider/NextAssetProvider';
import { AssetSlider } from '../AssetSlider/AssetSlider';
import { useSeries } from '../../hooks/SeriesProvider';
import { useCurrentAsset } from '../../hooks/CurrentAssetProvider';
import { isEpisode } from '../../utils/assetHelpers';
import { SeasonSlider } from '../SeasonSlider/SeasonSlider';

interface NextUpSliderProps {
  onAssetClick?: (asset: Asset, event: MouseEvent) => void;
}

export const NextUpSlider: FunctionComponent<NextUpSliderProps> = ({
  onAssetClick,
}) => {
  const { asset } = useCurrentAsset();
  const { nextAssets } = useNextAsset();
  const { seasons } = useSeries();

  if (!asset) {
    return null;
  }

  return (
    <div className="vgp-next-up-slider">
      {isEpisode(asset) ? (
        <SeasonSlider seasons={seasons} onAssetClick={onAssetClick} />
      ) : (
        <AssetSlider assets={nextAssets} onAssetClick={onAssetClick} />
      )}
    </div>
  );
};
